<div class="modal-header bg-primary rounded-top text-white">
    <h4 class="modal-title">{{ title }}</h4>
</div>

<div class="modal-body">
    <p>{{ message }}</p>
</div>